import { render, staticRenderFns } from "./CancelarTransacao.vue?vue&type=template&id=a23548c0"
import script from "./CancelarTransacao.vue?vue&type=script&lang=ts"
export * from "./CancelarTransacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports